"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconPropTypes = exports.iconDefaultProps = exports.isValidIcon = undefined;

var _arenaPropTypes = require("arena-prop-types");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isValidIcon = exports.isValidIcon = _propTypes2.default.oneOf(['alarm', 'angle', 'arrow', 'bar-chart', 'calendar', 'call', 'caution', 'chat', 'check', 'checkered-flag', 'cog', 'data-table', 'document', 'download', 'expand', 'file', 'glasses', 'location', 'locked', 'magnifying-glass', 'megaphone', 'message', 'minus', 'money', 'pdf', 'pencil', 'person', 'pie-chart', 'plus', 'shovel', 'spreadsheet', 'trash-can', 'unlocked', 'x']);

var iconDefaultProps = exports.iconDefaultProps = {
  fontSize: '1em',
  style: {},
  thick: false,
  thin: false,
  verticalAlign: 'top'
};
var iconPropTypes = exports.iconPropTypes = {
  fontSize: (0, _arenaPropTypes.numberOrStringPT)(),
  style: _propTypes2.default.shape({}),
  thick: _propTypes2.default.bool,
  thin: _propTypes2.default.bool,
  type: isValidIcon.isRequired,
  verticalAlign: _propTypes2.default.string
};